module.exports = "/images/blister-2.png";